export default "__VITE_ASSET__CjuNO7vr__"